import img9 from '../../assets/img/light sofa.jpg';
import img10 from '../../assets/img/reading table.jpg';
import img11 from '../../assets/img/corner table.jpg';
import img12 from '../../assets/img/office chair.jpg';
import img13 from '../../assets/img/book shelf.jpg';

const shopData = {
    shopData:[
        {
            id: 1,
            img: img9,
            title: "house sofa",
        },
        {
            id: 2,
            img: img10,
            title: "working table",
        },
        {
            id: 3,
            img: img11,
            title: "corner table",
        },
        {
            id: 4,
            img: img12,
            title: "office chair",
        },
        {
            id: 5,
            img: img13,
            title: "new wardrope",
        },
    ]
}  
export default shopData